import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';

import { tap } from 'rxjs/operators';

import * as fromRouter from './router.actions';
import { ChangeRoutePayload } from '@interfaces';

@Injectable()
export class RouterEffects {
  private readonly actions$ = inject(Actions);
  private readonly router = inject(Router);

  public routesHistory: ChangeRoutePayload[] = [];

  changeRoute$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRouter.changeRoute),
        tap((route: ChangeRoutePayload) => {
          const { extras, linkParams } = route;
          return this.router.navigate(linkParams, { ...extras });
        })
      ),
    { dispatch: false }
  );
}
